// src/components/SubscriptionSection.js

const SubscriptionSection = ({ t, addToRefs }) => {
  return (
    // Ana section'a yeni bir class ekleyerek özelleştiriyoruz
    <section 
      className="subscription-section-split theme-dark cb-slide-in" 
      ref={addToRefs}
    >
      <div className="container">
        {/* İçeriği iki sütuna ayıracak olan grid yapısı */}
        <div className="split-layout-grid">
          
          {/* Sol Sütun: Başlık */}
          <div className="split-layout-left">
            <h2 className="cb-title">
              {t('homePage.subscription.title')}
            </h2>
          </div>

          {/* Sağ Sütun: Açıklama ve Buton */}
          <div className="split-layout-right">
            <p className="cb-subtitle">
              {t('homePage.subscription.subtitle')}
            </p>
            <a 
              href="/contact" 
              className="btn-custom" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {t('homePage.subscription.button')}
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SubscriptionSection;